import React, { Component, PropTypes } from 'react';
import { browserHistory, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { fetchCategory, deleteCategory, editCategory, clearCategoriesErrors } from '../actions/';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import EditCategory from '../components/categories/EditCategory';
import Alert from '../components/home/Alert';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  categories: PropTypes.object,
  category: PropTypes.object,
  params: PropTypes.object,
  error: PropTypes.any,
};

class CategoryEditPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewRedirect: false,
      alertOpen: false,
      alertMessage: '',
      edited: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.push('/');
    }
  }
  componentDidMount() {
    this.props.dispatch(fetchCategory(this.props.params.id));
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      this.setState({
        alertOpen: true,
        edited: false,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
        error: true,
      });
    }
    if (nextProps.category && !nextProps.error && this.state.edited) {
      this.setState({
        alertOpen: true,
        alertMessage: 'Category edited succesfully!',
        error: false,
      });
    }
  }
  deleteCategory(categoryId) {
    const categories = this.props.categories;
    categories.delete = true;
    this.setState({ categories });
    this.props.dispatch(deleteCategory(categoryId));
    browserHistory.push('/categories?page=1');
  }
  saveEditCategory(category) {
    this.setState({
      edited: true,
    });
    const pCategory = category;
    pCategory.tagline = (category.tagline === null) ? '' : category.tagline;
    this.props.dispatch(editCategory(pCategory));
  }
  navigateToView(category) {
    const nextState = this.state;
    nextState.viewRedirect = true;
    nextState.edited = true;
    this.setState(nextState);
    this.props.dispatch(editCategory(category));
  }
  alertHandleClose() {
    this.setState({
      alertOpen: false,
      edited: false,
      alertMessage: '',
    });
    this.props.dispatch(clearCategoriesErrors());
    if (!this.state.error) {
      if (this.state.viewRedirect === true) {
        this.setState({ viewRedirect: false });
        browserHistory.push(`/categories/view/${this.props.category.id}`);
      } else {
        browserHistory.push('/categories?page=1');
      }
    }
  }
  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="category component" style={authPage}>
        <h2>Edit Category</h2>
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <div className="content">
          <EditCategory
            category={this.props.category}
            onSave={data => this.saveEditCategory(data)}
            onDelete={data => this.deleteCategory(data)}
            onView={data => this.navigateToView(data)}
          />
        </div>
      </div>
    );
  }
}

CategoryEditPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

CategoryEditPage.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    categories: state.categories,
    category: state.categories.category,
    error: state.categories.error,
  };
}

export default withRouter(connect(mapStateToProps)(CategoryEditPage));



// WEBPACK FOOTER //
// ./src/containers/CategoryEditPage.js